import React from "react";

const SummaryCard = ({ title, amount, icon, color = "blue" }) => (
  <div className={`summary-card ${color}`}>
    <div className="card-icon">{icon}</div>
    <div className="card-info">
      <div className="card-title">{title}</div>
      <div className="card-amount">₹{amount.toLocaleString(undefined, { maximumFractionDigits: 2 })}</div>
    </div>
  </div>
);

export default SummaryCard;
